<template>
    <el-container>
        
        <el-main>
            <el-form ref="searchDate" :model="searchData" label-width="80px" label-position="top">
                <el-row>
                    <el-col :span="4" class="cls-col">
                        <el-form-item label="课程名称" prop="name">
                            <el-input v-model="searchData.name" placeholder="课程名称" size="small"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4" class="cls-col">
                        <el-form-item label="用户名" prop="userName">
                            <el-input v-model="searchData.userName" placeholder="用户名" size="small"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="orgType == 1" :span="4" class="cls-col">
                        <el-form-item label="所属机构" prop="orgCode">
                            <el-select size="small" placeholder="所属机构" clearable v-model="searchData.orgCode" clearable style="width: 100%" @change="changeOrg">
                                <el-option v-for="o in org" :label="o.organizationName" :value="o.orgCode"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4" class="cls-col">
                        <el-form-item label="课程分类:" :inline="true"  >
                            <el-cascader
                                expand-trigger="hover"
                                :options="categoryOptions"
                                style="width: 100%"
                                size="small"
                                clearable
                                :props="{ value: 'courseTypeId', label: 'courseTypeName',children: 'childNodeLst'}"
                                v-model="selectedCourse"
                                @change="changeCourse">
                            </el-cascader>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4" class="cls-col">
                        <el-form-item label="审核状态" prop="status">
                            <el-select v-model="searchData.status" clearable placeholder="审核状态" size="small" style="width: 100%">
                                <el-option label="待审核" :value="1"></el-option>
                                <el-option label="通过" :value="2"></el-option>
                                <el-option label="未通过" :value="3"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item>
                    <el-button type="primary" plain size="small" icon="el-icon-search" @click="search()">查询</el-button>
                </el-form-item>
            
            </el-form>
            <el-table
                :data="courseReviewData"
                border
                highlight-current-row
                v-loading="loading"
                style="width: 100%"
            >
                <el-table-column
                    type="index"
                    label="序号"
                    width="50"
                    fixed="left"
                >
                </el-table-column>
                <el-table-column
                    prop="name"
                    label="课程名称"
                    fixed="left"
                >
                </el-table-column>
                <el-table-column
                    prop="orgName"
                    label="所属机构"
                    fixed="left"
                >
                </el-table-column>
                <el-table-column
                    prop="userName"
                    label="用户名"
                    width="200"
                >
                </el-table-column>
                <el-table-column
                    prop="courseTypeName"
                    label="课程分类"
                    width="200"
                >
                </el-table-column>
                <el-table-column
                    prop="status"
                    label="审核状态"
                    width="130"
                    :formatter="f_status"
                >
                </el-table-column>
                
                <el-table-column
                    prop="commitTime"
                    label="提交时间"
                    width="200"
                >
                </el-table-column>
                <el-table-column
                    fixed="right"
                    label="操作"
                    width="200"
                >
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="courseReview(scope.row)"
                                   v-if="scope.row.status == 1">审核
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                layout="prev, pager, next"
                :total="total"
                :page-size="pageSize"
                :current-page.sync="currentPage"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                style="margin-top: 10px; float: right; margin-right: 10px">
            </el-pagination>
        </el-main>
    </el-container>
</template>

<script>
    import https from '@/https.js';
    import validate from '@/api/validate.js';
    import {dateFormat} from '@/api/utils.js';

    export default {
        data() {
            return {
                courseReviewData: [],
                loading: false,
                org: [],
                orgType: '',
                categoryOptions: [],
                selectedCourse: [],
                searchData: {
                    orgCode: '',
                    name: '',
                    status: '',
                    categoryOne: '',
                    categoryTwo: '',
                    categoryThree: '',
                    userName: '',
                    limit: 0,
                    page: 1
                },
                rules: {
                    userName: [
                        {required: true, message: '请输入用户名', trigger: 'blur'},
                        {min: 6, max: 20, message: '长度为6-20 个字符', trigger: 'blur'}
                    ],
                    phone: [
                        {required: true, message: '请输入电话', trigger: 'blur'},
                        {validator: validate.validatePhone, trigger: 'blur'}
                    ],
                    realName: [
                        {max: 50, message: '长度不得超过50个字符', trigger: 'blur'}
                    ],
                    email: [
                        {validator: validate.validateEmail, trigger: 'blur'}
                    ],
                    qq: [
                        {validator: validate.validateQQ, trigger: 'blur'}
                    ],
                    education: [
                        {max: 50, message: '长度不得超过50个数字', trigger: 'blur'}
                    ],
                    province: [
                        {max: 50, message: '长度不得超过50个数字', trigger: 'blur'}
                    ]
                },
                total: 0,
                pageSize: 10,
                currentPage: 1,
                courseData: [],
                courseChild: [],
                courseChildData: {}
            };
        },
        methods: {
          changeOrg() {
            this.categoryOptions = [];
            this.selectedCourse = [];
            this.searchCourseType()
          },
            f_status(row, column, cellValue, index) {
                if (cellValue == 1) {
                    return '待审核';
                }
                if (cellValue == 2) {
                    return '通过';
                }
                if (cellValue == 3) {
                    return '未通过';
                }
            },

            search(val) {
                if (val) {
                    this.searchData.page = val;
                } else {
                    this.searchData.page = 1;
                    this.currentPage = 1;
                }
              if(this.selectedCourse.length > 0) {
                  if(this.selectedCourse.length == 3) {
                    this.searchData.categoryOne = this.selectedCourse[0];
                    this.searchData.categoryTwo = this.selectedCourse[1];
                    this.searchData.categoryThree = this.selectedCourse[2];
                  }
                if(this.selectedCourse.length == 2) {
                  this.searchData.categoryOne = this.selectedCourse[0];
                  this.searchData.categoryTwo = this.selectedCourse[1];
                }
                if(this.selectedCourse.length == 1) {
                  this.searchData.categoryOne = this.selectedCourse[0];
                }
              } else {
                this.searchData.categoryOne = "";
                this.searchData.categoryTwo = "";
                this.searchData.categoryThree = "";
              }
              
                this.searchData.limit = this.pageSize;
                let params = this.searchData;
                this.loading = true;
                https.fetchPost('/courseCheck/list', JSON.parse(JSON.stringify(params)), 'json').then((data) => {
                    let code = data.data.code;
                    let msg = data.data.msg;
                    if (code == '200') {
                        this.courseReviewData = data.data.data;
                        this.total = data.data.total;
                        this.loading = false;
                    } else {
                        this.loading = false;
                        this.$message({
                            type: 'info',
                            message: msg
                        });
                    }
                }).catch(err => {
                        console.log(err);
                        this.loading = false;
                        this.$message.error('数据加载失败');
                    }
                );
            },
            handleSizeChange() {
            },

            handleCurrentChange(val) {
                this.search(val);
            },
          searchCourseType() {
            if(this.searchData.orgCode == '') {
              return;
            }
            this.categoryOptions = [];
            let params = {
              orgCode: this.searchData.orgCode
            };
            this.https.fetchPost('/courseType/courseTypeOfCourseCheck', params, 'json').then((data) => {
              let code = data.data.code;
              let msg = data.data.msg;
              if (code == 200) {
                this.categoryOptions = data.data.data.childNodeLst;
              } else {
                this.$message({
                  type: 'info',
                  message: '加载失败:' + msg
                });
              }

            }).catch(err => {
                  console.log(err);
                  this.$message.error('网络错误');
                }
            );
          },
            loadCourseCategory() {
              let params = {
                orgCode: this.$store.state.eblcuOrg
              };
                https.fetchPost('/courseCategoryInfo/selectListRecursion', params, 'json').then((data) => {
                    let code = data.data.code;
                    if (code == 200) {
                      this.categoryOptions = data.data.data;
                    } else {
                        this.$message({
                            type: 'info',
                            message: '加载失败：' + msg
                        });
                    }

                }).catch(err => {
                        this.$message.error('网络错误');
                    }
                );
            },
            changeCourse(val) {
                if(val) {
                  this.courseChild = this.courseChildData[val];
                }
              this.searchData.categoryTwo = '';
              
            },
            courseReview(row) {
              let params = {
                courseId: row.courseId
              }
                this.$router.push({
                    name: 'courseReview',
                    query: params
                });
            },
          selectOrg() {
            this.https.fetchGet('/managerOrganization/getOrganizationList', '', 'from').then((data) => {
              let code = data.data.code;
              let msg = data.data.msg;
              if (code == 200) {
                this.org = data.data.data;
              } else {
                this.$message({
                  type: 'info',
                  message: msg
                });
              }

            }).catch(err => {
                  console.log(err);
                  this.$message.error('网络错误');
                }
            );
          },
        },
        created: function() {
            this.orgType = this.$store.state.orgType;
            if(this.orgType != 1) {
              this.searchData.orgCode = this.$store.state.orgCode;
            }
            this.search();
            this.selectOrg();
            this.searchCourseType();
        }
    };
</script>

<style scoped>
    .but-cls {
        margin-bottom: 10px;
    }
    
    .cls-col {
        margin-right: 20px;
    }
</style>
